import { useContext } from 'react';

import SearchContext from 'src/contexts/SearchContext';

const useSearcher = () => useContext(SearchContext);

export default useSearcher;
